<template>
  <div class="relative h-[500px] md:h-[600px] lg:h-[650px] overflow-hidden">
    <!-- Background Image with Overlay -->
    <div class="absolute inset-0">
      <img
        :src="heroImage"
        alt="Umrah Header"
        class="w-full h-full object-cover scale-105 transition-transform duration-700 hover:scale-100"
      />
      <!-- Gradient Overlay -->
      <div class="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-amber-900/50"></div>
    </div>

    <!-- Hero Content -->
    <div class="relative h-full flex items-center justify-center px-4">
      <div class="container mx-auto">
        <div class="text-center max-w-4xl mx-auto">
          <!-- Label Text -->
          <p class="text-base md:text-lg uppercase tracking-[0.6em] text-amber-400 mb-4 font-semibold">
            Your Spiritual Journey Begins Here
          </p>

          <!-- Main Heading -->
          <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Welcome to Al Etimad Haramain Travel
          </h1>

          <!-- Description -->
          <p class="text-base md:text-lg lg:text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed font-normal">
            Umrah packages, Haramain Ziarat tours, flight bookings, and hotel reservations for Makkah &amp; Madina —
            all arranged with premium care for your spiritual journey.
          </p>

          <div class="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <router-link
              to="/packages"
              class="w-full sm:w-auto rounded-lg bg-gradient-to-r from-amber-500 to-amber-600 px-8 py-3.5 text-sm font-semibold uppercase tracking-wide text-white shadow-lg shadow-amber-500/30 transition hover:from-amber-600 hover:to-amber-700 hover:shadow-amber-500/50"
            >
              View Umrah Packages
            </router-link>
            <router-link
              to="/hotels"
              class="w-full sm:w-auto rounded-lg border border-white/40 bg-white/10 px-8 py-3.5 text-sm font-semibold uppercase tracking-wide text-white backdrop-blur transition hover:bg-white/20"
            >
              Browse Hotels
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import heroImage from '../assets/images/makkah/kaaba-crowd-daytime.avif'

export default {
  name: 'HeroSection',
  data() {
    return {
      heroImage: heroImage
    }
  }
}
</script>
